import { memo } from 'react';
import { Link } from 'react-router-dom';
import type { TicketMailInfo } from '@/shared/api';
import { cn } from '@/shared/lib/cn';
import styles from './TicketDetail.module.css';

const MailThreadCardBase: React.FC<{ info: TicketMailInfo }> = ({ info }) => {
  const requester = info.requester;
  const notes: { text: React.ReactNode; warn?: boolean }[] = [];
  notes.push({
    text: requester?.isContact
      ? 'Заявитель без учётки: в портал не входит и видит только письма. Сообщение чата уходит ему, когда отправлено письмом.'
      : 'Ответы заявителя письмом попадают в чат. Сообщение чата уходит письмом, когда так отправлено.',
  });
  if (requester?.undeliverable) {
    notes.push({ text: 'Последнее письмо вернулось недоставленным — проверьте адрес.', warn: true });
  }
  if (!info.canSendEmail && info.cannotSendReason) {
    notes.push({ text: `Письмом сейчас не отправить: ${info.cannotSendReason.toLowerCase()}.`, warn: true });
  }
  if (info.suggestion) {
    notes.push({
      text: (
        <>
          Похоже на продолжение заявки{' '}
          <Link to={`/tickets/view/${info.suggestion.ticketId}`}>
            №{info.suggestion.number} «{info.suggestion.subject}»
          </Link>
          . Если так — перенесите сообщения туда через меню сообщения.
        </>
      ),
    });
  }
  return (
    <div className={styles.card}>
      <h2 className={styles.cardTitle}>Переписка по почте</h2>
      <dl className={styles.infoGrid}>
        {requester?.address && (
          <div className={styles.infoCell}>
            <dt className={styles.infoCellLabel}>Заявитель</dt>
            <dd className={styles.infoCellValue}>{requester.address}</dd>
          </div>
        )}
        {info.mailbox && (
          <div className={styles.infoCell}>
            <dt className={styles.infoCellLabel}>Ящик</dt>
            <dd className={styles.infoCellValue}>{info.mailbox.address}</dd>
          </div>
        )}
        {info.cc.length > 0 && (
          <div className={cn(styles.infoCell, styles.infoCellWide)}>
            <dt className={styles.infoCellLabel}>Копия</dt>
            <dd className={styles.infoCellValue}>{info.cc.map((c) => c.address).join(', ')}</dd>
          </div>
        )}
      </dl>
      {notes.map((n, i) => (
        <p key={i} className={cn(styles.mailNote, n.warn && styles.mailNoteWarn)}>
          {n.text}
        </p>
      ))}
    </div>
  );
};

export const MailThreadCard = memo(MailThreadCardBase);
